import React from 'react';

const BtnUnderLine = (props) => {
  return (
    <div className='btn-underline-container'>
      <button className={'btn-underline'} onClick={props.onClick}>
        <span className='btn-underline-text'>{props.text}</span>
      </button>
    </div>
  );
};

export default BtnUnderLine;
